import workspaceQuery from '../../queries/supplier/PurchasePaymentTermWorkspaceQuery.graphql';
import listQuery from '../../queries/supplier/PurchasePaymentTermListQuery.graphql';
import instanceQuery from '../../queries/supplier/PurchasePaymentTermQuery.graphql';
import defaultQuery from '../../queries/supplier/PurchasePaymentTermDefault.graphql';
import mutationQuery from '../../mutations/supplier/PurchasePaymentTermMutation.graphql';
import fragment from '../../fragments/supplier/PurchasePaymentTermFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchasePaymentTerm: EntityType = {
  type: 'PurchasePaymentTerm',
  title: 'Purchase Payment Terms',
  formTitle: 'Payment Term',
  formUrl: '/Suppliers/PaymentTerm/Details/',
  workspaceUrl: '/Suppliers/PaymentTerm/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SUPPLIER_PAYMENT_TERMS',
};

export default PurchasePaymentTerm;
